import React from 'react';
import {
  Box,
  Container,
  Typography,
  IconButton,
  Divider,
  Link as MuiLink,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  Facebook,
  Instagram,
  Twitter,
  WhatsApp,
  Phone,
  Email,
  LocationOn,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              {t('home.title')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              {t('home.heroDescription')}
            </Typography>
            
            {/* Social Media Icons */}
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                href="https://facebook.com"
                target="_blank"
                sx={{ color: 'white', '&:hover': { color: '#1877F2' } }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                href="https://instagram.com"
                target="_blank"
                sx={{ color: 'white', '&:hover': { color: '#E4405F' } }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                href="https://twitter.com"
                target="_blank"
                sx={{ color: 'white', '&:hover': { color: '#1DA1F2' } }}
              >
                <Twitter />
              </IconButton>
              <IconButton
                href="https://wa.me/919838167840"
                target="_blank"
                sx={{ color: 'white', '&:hover': { color: '#25D366' } }}
              >
                <WhatsApp />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 12, md: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('nav.home')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink
                component={Link}
                to="/"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9 }}
              >
                {t('nav.home')}
              </MuiLink>
              <MuiLink
                component={Link}
                to="/services"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9 }}
              >
                {t('nav.services')}
              </MuiLink>
              <MuiLink
                component={Link}
                to="/about"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9 }}
              >
                {t('nav.about')}
              </MuiLink>
              <MuiLink
                component={Link}
                to="/contact"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9 }}
              >
                {t('nav.contact')}
              </MuiLink>
            </Box>
          </Grid>

          {/* Services */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('services.title')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('services.pujaTitle')}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('services.astroTitle')}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('services.tantrikTitle')}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('services.gemstoneTitle')}
              </Typography>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('contact.title')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 18 }} />
                <MuiLink
                  href="tel:+918743904604"
                  color="inherit"
                  underline="hover"
                  sx={{ opacity: 0.9 }}
                >
                  +91 87439 04604
                </MuiLink>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 18 }} />
                <MuiLink
                  href="mailto:info@acharyaabhishek.com"
                  color="inherit"
                  underline="hover"
                  sx={{ opacity: 0.9 }}
                >
                  info@acharyaabhishek.com
                </MuiLink>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOn sx={{ fontSize: 18, mt: 0.2 }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  New Delhi, India
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />

        {/* Copyright */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} {t('home.title')}. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Made with ❤️ for spiritual guidance
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;